var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var LOG_KEY = "shopping-bag-provider";
var getTime = function () {
    var date = new Date();
    var LAST_TWO_DIGITS = -2;
    var LAST_THREE_DIGITS = -3;
    return date.getHours() + ":" + ("0" + date.getMinutes()).slice(LAST_TWO_DIGITS) + ":" + ("0" + date.getSeconds()).slice(LAST_TWO_DIGITS) + "." + ("00" + date.getMilliseconds()).slice(LAST_THREE_DIGITS);
};
export var isLoggerOn = function () {
    var _a;
    return Boolean(window.localStorage) &&
        Boolean(JSON.parse((_a = localStorage.getItem(LOG_KEY + " debug")) !== null && _a !== void 0 ? _a : "0"));
};
export var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!isLoggerOn()) {
        return;
    }
    var time = getTime();
    console.log.apply(console, __spreadArrays(["%c" + time + " %c" + LOG_KEY + ":", "color: #09c",
        "color: #c90;"], args));
};
export var logReceivedEvent = function (event) {
    return log("Received " + event.type + " event:\n\t", event);
};
